<template>
  <div class="main">
    <div class="list"><el-link href="/fec/sbu3" type="primary" target="_blank">综述小论文</el-link></div>
    <div class="list"><el-link href="/fec/sbu5" type="primary" target="_blank">医学论文</el-link></div>
    <div class="list"><el-link href="/fec/sbu6" type="primary" target="_blank">病例小报告</el-link></div>
    <div class="list"><el-link href="/fec/sbu7" type="primary" target="_blank">文脉灵感</el-link></div>
    <div class="list"><el-link href="/fec/sbu8" type="primary" target="_blank">文脉灵感极速版</el-link></div>
    <div class="list"><el-link href="/fec/sbu9" type="primary" target="_blank">文脉灵感指定标题</el-link></div>
    <div class="list"><el-link href="/fec/sbu11" type="primary" target="_blank">文脉灵感指定标题极速版</el-link></div>
    <div class="list"><el-link href="/fec/sbu12" type="primary" target="_blank">胡建强教学论文</el-link></div>
    <div class="list"><el-link href="/fec/sbu13" type="primary" target="_blank">胡建强教学论文指定标题</el-link></div>
    <div class="list"><el-link href="/fec/sbu14" type="primary" target="_blank">胡建强调教版</el-link></div>
  </div>
</template>

<script setup>
</script>

<style scoped>
  .main{
    padding: 30px;
  }
</style>
